import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { StripePaymentComponent } from '../../stripe-payment/stripe-payment.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';
import { PaginationInstance } from 'ngx-pagination';
import { Filter } from '../../filter/filter.model';
import { AppService } from 'src/app/services/app/app.service';
import { InfoModalComponent } from '../../dialog-modal/info-modal/info-modal.component';
import { Info } from 'angular-feather/icons';
//here t=type of course and its type are 
//m_cs = my coruse 

@Component({
  selector: 'app-course-dashboard-c',
  templateUrl: './course-dashboard-c.component.html',
  styleUrls: ['./course-dashboard-c.component.scss', '../../../../assets/scss/common/_course-box.scss']
})
export class CourseDashboardCComponent {

  public imageURL: any = GlobalService.imageURL
  public courseArr: any[] = [];
  public vatPercentage: any;
  public isSpinnerLoading: boolean = false;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Description", key_val: "desc", type: 'text' },
  ]
  public count!: number;
  public isFilterShow: boolean = false;
  public searchInput: string = '';
  private previousInputValue: string = '';

  constructor(private courseService: CourseService, private individualService: IndividualService, private router: Router, private dialog: MatDialog,
    private commonService: CommonService, private appService: AppService) { }
  ngOnInit(): void {
    this.commonService.setTitle("Courses")
    // this.list()
    this.onPageChange(1)
  }
  list() {
    // this.spinner.show();
    this.courseArr = []
    let obj = {
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    this.isSpinnerLoading = true
    this.individualService.courseList(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.previousInputValue = this.searchInput;
          this.courseArr = success.data.listArr;
          this.vatPercentage = success.vat;
          this.count = success.data.total_record;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        this.commonService.handleError(error)
      }
    }
    );
  }

  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.list()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.list()
  }
  doFilter = (event: any) => {
    let newVal = event.target?.value
    // this.dataSource.filter = newVal.trim().toLocaleLowerCase()
  }
  callApi(obj) {
    this.filterObj = obj
    this.list()
  }
  onFilterView() {
    this.isFilterShow = !this.isFilterShow;
    // if (this.isFilterShow == true) { this.filterArr = [{ filter_value: '', contains: '', containsArr: [''] }] }
  }
  onViewCourse(item) {
    // this.router.navigate(['/course/course-details-c'])
    this.router.navigate(['/course/course-details-c'], { queryParams: { c_i: item.id, referral_code: "", t: "b_cs", c_t: item.t } })
  }
  setBgImg(image: any, i: any) { }
  onBuyCourse(id, item) {
    // let data = {
    //   id: id,
    // }
    // data = Object.assign(data, item)
    // data["id"] = id;
    // data["vat_percentage"] = this.vatPercentage
    // // send type as 1 as it will be always single course
    // data["type"] = 1
    // const dialogRef = this.dialog.open(StripePaymentComponent, {
    //   width: '95%',
    //   height: '98%',
    //   minWidth:'300px',
    //   maxHeight:'850px',
    //   maxWidth: '1090px',
    //   panelClass: 'addCourseModal',
    //   enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
    //   data: data,
    //   autoFocus: false
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // });

    const dialogRef = this.dialog.open(InfoModalComponent, {
      data: {
        type:'info_mess'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      
    });
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 0
      this.onPageChange(1)
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 0
      this.onPageChange(1)
    }
  }
}
